/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var BannerAlertType;
(function (BannerAlertType) {
    BannerAlertType["ERROR"] = "ERROR";
    BannerAlertType["WARNING"] = "WARNING";
    BannerAlertType["SUCCESS"] = "SUCCESS";
    BannerAlertType["INFO"] = "INFO";
})(BannerAlertType || (BannerAlertType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFubmVyLWFsZXJ0LXR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL2Jhbm5lci1hbGVydHMvYmFubmVyLWFsZXJ0LXR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxlQUtYO0FBTEQsV0FBWSxlQUFlO0lBQ3ZCLGtDQUFlLENBQUE7SUFDZixzQ0FBbUIsQ0FBQTtJQUNuQixzQ0FBbUIsQ0FBQTtJQUNuQixnQ0FBYSxDQUFBO0FBQ2pCLENBQUMsRUFMVyxlQUFlLEtBQWYsZUFBZSxRQUsxQiJ9